import { getAuthSessionKind, getDoctorSessionCacheKey, getStoredTenantId } from "../../../utils/authSession";
export function normalizeWorkspaceSource(input, fallbackId = null) {
  const source = input && typeof input === "object" ? input : { id: input || fallbackId };
  const kind = source.kind || "import_job";
  if (!["import_job", "file", "workspace_dataset"].includes(kind)) throw new Error("DW_SOURCE_TYPE_MISMATCH");
  return { kind, id: source.id == null ? null : String(source.id) };
}

export function workspaceSourceKey(source) {
  const { kind, id } = normalizeWorkspaceSource(source);
  return `${kind}:${id || ""}`;
}

export function workspaceHref(source, { cleaningJob = null } = {}) {
  const normalized = normalizeWorkspaceSource(source);
  const query = new URLSearchParams();
  if (normalized.kind !== "import_job") query.set("source_kind", normalized.kind);
  if (cleaningJob) query.set("cleaningJob", cleaningJob);
  return `/data-workspace/${encodeURIComponent(normalized.id)}${query.toString() ? `?${query}` : ""}`;
}

export function workspaceSessionIdentity() {
  return `${getAuthSessionKind() || ""}|${getStoredTenantId() || ""}|${getDoctorSessionCacheKey()}`;
}
export function workspaceContextKey(input, { mode, versionId } = {}) {
  const source = normalizeWorkspaceSource(input?.source || input);
  const selectedMode = mode || input?.mode || "working";
  const version = versionId ?? input?.versionId ?? input?.version_id ?? null;
  return `v2:${encodeURIComponent(workspaceSessionIdentity())}:${workspaceSourceKey(source)}:${selectedMode}:${version || "-"}`;
}
export function analysisHref(target, selection) {
  const source = normalizeWorkspaceSource(selection.source || selection);
  const paths = { stats: "statistical-analysis", prognosis: "feature-impact", ml: "machine-learning" };
  if (!paths[target]) throw new Error("DW_ANALYSIS_SOURCE_NOT_APPLICABLE");
  const query = new URLSearchParams({ datasetId: source.id, source_kind: source.kind, mode: selection.mode || "working" });
  if (selection.mode === "saved" && (selection.version_id || selection.versionId)) query.set("version_id", selection.version_id || selection.versionId);
  return `/${paths[target]}?${query}`;
}
